import { getState, snapshot } from "../mock/demoAdminState"

function ok(data) {
  return { status: 200, data: snapshot(data) }
}

function delay(ms = 80) {
  return new Promise((resolve) => setTimeout(resolve, ms))
}

function pathOf(url = "") {
  return String(url).replace(/\?.*$/, "")
}

/**
 * Axios-shaped client used only in the demo build.
 * Handles authenticate, /user/:id, and REDCap /export|/import stubs.
 */
const demoClient = {
  async get(url) {
    await delay()
    const path = pathOf(url)
    const userMatch = path.match(/^\/?user\/(\d+)$/)
    if (userMatch) {
      const state = getState()
      const id = Number(userMatch[1])
      const user = state.users.find((u) => u.id === id) || state.user
      return ok(user)
    }
    console.warn("[FlexTLFB admin demo] Unhandled GET", path)
    return ok(null)
  },

  async post(url, body = {}) {
    await delay()
    const path = pathOf(url)

    if (path === "/authenticate" || path.endsWith("/authenticate")) {
      return ok({ valid: true })
    }
    if (path === "/login" || path.endsWith("/login")) {
      return ok({ token: localStorage.getItem("access-token") })
    }
    if (path === "/export" || path.endsWith("/export")) {
      return handleExport(body)
    }
    if (path === "/import" || path.endsWith("/import")) {
      return handleImport(body)
    }

    console.warn("[FlexTLFB admin demo] Unhandled POST", path, body)
    return ok({})
  },

  async put(url, body = {}) {
    await delay()
    console.log("[FlexTLFB admin demo] PUT discarded:", pathOf(url), body)
    return ok(body)
  },

  async delete(url) {
    await delay()
    console.log("[FlexTLFB admin demo] DELETE discarded:", pathOf(url))
    return ok({})
  }
}

function handleExport(body) {
  const state = getState()
  const projectId = body.projectId
  const info = state.projectInfoByProjectId[projectId] || {
    project_title: "Demo REDCap Project",
    in_production: 0
  }

  switch (body.content) {
    case "projectinfo":
      return ok(info)
    case "fieldnames":
      return ok(state.fieldnames)
    case "testLink": {
      const surveyBase =
        process.env.VUE_APP_SURVEY_SITE_URL || "https://flextlfb-demo.pages.dev"
      const publicId =
        state.redcapApiTokens.find((t) => t.project?.id === projectId)?.project
          ?.publicId || "demo"
      return ok([
        {
          field_label: `${surveyBase}/${publicId}/[record_id]`
        }
      ])
    }
    case "nextRecord":
      return ok({ nextRecord: state.nextRecord })
    case "recordIds":
      return ok([{ record_id: String(state.nextRecord) }])
    default:
      console.warn("[FlexTLFB admin demo] Unhandled export content", body.content)
      return ok({})
  }
}

function handleImport(body) {
  const state = getState()
  switch (body.content) {
    case "newRecord":
      state.nextRecord += 1
      return ok({ record: state.nextRecord })
    case "destroySurveyData":
    case "destroyCalendar":
    case "records":
      console.log("[FlexTLFB admin demo] Import no-op:", body.content)
      return ok({})
    default:
      console.warn("[FlexTLFB admin demo] Unhandled import content", body.content)
      return ok({})
  }
}

export default demoClient
